import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { UspGroupItem } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useFeatureToggles } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import '../../../slots/context.js';
import { useCartHeaderActionSlots } from '../../../slots/header-slot/context.js';
import { useCartSidebarSlots } from '../../../slots/sidebar-slot/context.js';
import { extractSkuQuantityPairsFromLineItems } from '../../../utils/extract-sku-qauntity-pairs.js';
import { UnavailableLineItemsContainer } from '../../LineItems/containers/UnavailableLineItemsContainer.js';
import { VisualLineItemsContainer } from '../../LineItems/VisualLineItemsContainer/VisualLineItemsContainer.js';
import { PrescriptionAlertMessage } from '../../PrescriptionAlertMessage/PrescriptionAlertMessage.js';
import { SummaryContainer } from '../../Summary/SummaryContainer.js';

const Cart = ({ cartId , deliveryResolver , donation , hasSubscription , isReadOnly , labels , lineItems , policyItems , isMixedBasketAlert =false , unavailableLineItems , visualLineItems  })=>{
    const { Slots: CartHeaderComponents  } = useCartHeaderActionSlots();
    const { Slots: CartSidebarComponents  } = useCartSidebarSlots();
    const [{ cartHash  }] = useCartStorage();
    const { isCartDeliveryIndicatorEnabled  } = useFeatureToggles();
    // This will be used when the basic variant of the DeliveryIndicator is enabled
    const availability = lineItems.map((item)=>item.availability
    );
    // This will be used if the full date variant of the DeliveryIndicator is enabled (feature toggle)
    const deliveryItems = extractSkuQuantityPairsFromLineItems(lineItems).filter(isDefined);
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('cart', {
            'cart--read-only': isReadOnly
        }),
        "data-t": "cart"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "cart__heading"
    }, labels.cartTitle), isMixedBasketAlert ? /*#__PURE__*/ React.createElement(Alert, {
        className: "cart__alert",
        title: labels.alertMixedBasketTitle,
        variant: "info"
    }, labels.alertMixedBasketDescription) : null, CartHeaderComponents.FirstComponent ? /*#__PURE__*/ React.createElement(CartHeaderComponents.FirstComponent, {
        cartId: cartId
    }) : !!lineItems.length && isCartDeliveryIndicatorEnabled && /*#__PURE__*/ React.createElement(DeliveryIndicator, {
        items: deliveryItems,
        availability: availability,
        deliveryResolver: deliveryResolver
    }), /*#__PURE__*/ React.createElement("div", {
        className: "cart__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart__main"
    }, /*#__PURE__*/ React.createElement(VisualLineItemsContainer, {
        lineItems: visualLineItems,
        isReadOnly: isReadOnly
    }), !isReadOnly && /*#__PURE__*/ React.createElement(PrescriptionAlertMessage, {
        lineItems: visualLineItems,
        className: "cart__rx-alert"
    }), /*#__PURE__*/ React.createElement(UnavailableLineItemsContainer, {
        unavailableLineItems: unavailableLineItems,
        labels: labels
    }), policyItems && /*#__PURE__*/ React.createElement("div", {
        className: "usp-group__container"
    }, policyItems.map((item)=>/*#__PURE__*/ React.createElement(UspGroupItem, {
            item: item,
            key: item.text
        })
    ))), /*#__PURE__*/ React.createElement("aside", {
        className: "cart__sidebar"
    }, !isReadOnly && CartSidebarComponents.FirstComponent && /*#__PURE__*/ React.createElement(CartSidebarComponents.FirstComponent, {
        cartId: cartId,
        cartHash: cartHash
    }), CartSidebarComponents.SecondComponent && /*#__PURE__*/ React.createElement(CartSidebarComponents.SecondComponent, {
        isReadOnly: isReadOnly
    }), /*#__PURE__*/ React.createElement(SummaryContainer, swcHelpers.extends({
        isReadOnly: isReadOnly,
        hasSubscription: hasSubscription
    }, (donation === null || donation === void 0 ? void 0 : donation.amount) && {
        donationAmount: donation.amount
    })))));
};

export { Cart };
//# sourceMappingURL=Cart.js.map
